
import React from 'react';
import AdminLayout from '@/components/admin/AdminLayout';

const CertificatesPage: React.FC = () => {
  return (
    <AdminLayout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">Certificates</h1>
        <p className="mt-4">Manage certificate templates and issued certificates.</p>
      </div>
    </AdminLayout>
  );
};

export default CertificatesPage;
